import { Tab as MTab, TabProps } from '@mui/material'

export const Tab: React.FC<TabProps> = (props) => {
  return <MTab {...props} />
}
